export default __webpack_public_path__ + "static/media/fireFN7.b5f9325d.svg";